import {Component, model} from '@angular/core';
import {IconsComponent} from '../icons/icons.component';
import {ButtonComponent} from '../button/button.component';

@Component({
  selector: 'app-dropdown',
  imports: [
    IconsComponent,
    ButtonComponent
  ],
  templateUrl: './dropdown.component.html',
  host: {'(document:click)': 'onClickOutside($event)'},
  styleUrl: './dropdown.component.css',
})
export class DropdownComponent extends ButtonComponent {
  isOpen = model<boolean>(false);

  headerID = `dropdown-button-${Math.random().toString(36).substring(2, 9)}`;
  bodyID = `dropdown-menu-${Math.random().toString(36).substring(2, 9)}`;

  onClickOutside(event: MouseEvent) {
    if (this.isOpen() && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
    }
  }

  toggle() {
    this.isOpen.set(!this.isOpen());
  }
}
